module.exports = __webpack_public_path__ + "static/media/haute13B.2c565f58.jpg";